import { render } from "./Wz5Details.vue?vue&type=template&id=4500d9ea&scoped=true"
import script from "./Wz5Details.vue?vue&type=script&lang=js"
export * from "./Wz5Details.vue?vue&type=script&lang=js"

import "./Wz5Details.vue?vue&type=style&index=0&id=4500d9ea&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4500d9ea"]])

export default __exports__